<template>
  <div>
    <div class="con4_h5">{{ title }}</div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(img, index) in imgs" :key="index">
          <img :src="img" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  props: {
    title: String,
    imgs: Array,
  },
  mounted() {
    const swiper = new Swiper('.swiper-container', {
      direction: 'horizontal', // 垂直切换选项
      loop: true, // 循环模式选项
      pagination: { el: '.swiper-pagination' },
      autoplay: false,
    })
    console.info(swiper)
  },
}
</script>

<style lang="less" scoped>
@import '../../../../assets/css/swiper.min.css';

.con4_h5 {
  width: 100%;
  margin-top: 0.9rem;
  color: #333;
  font-size: 0.44rem;
  font-weight: 600;
  text-align: center;
}

.swiper-wrapper,
.swiper-wrapper .swiper-slide {
  width: 6.88rem;
  height: 8.9rem;
}

.swiper-wrapper .swiper-slide img {
  height: 8rem;
  margin: 0.31rem auto;
  width: auto;
}

.swiper-pagination-bullet-active {
  background: #fa4a5a !important;
}

.my-bullet-active {
  background: #fa4a5a !important;
  opacity: 1;
  position: absolute;
  bottom: 0;
}
</style>
